import { createSeedData } from "../data/seed";
import type { AppData, Id } from "../types";

const STORAGE_KEY = "groomer-book-pro:data:v2";

function isAppData(data: AppData) {
  return Array.isArray(data.owners) && Array.isArray(data.pets) && Array.isArray(data.appointments);
}

function mergeById<T extends { id: Id }>(seed: T[], persisted: T[]) {
  const merged = new Map<Id, T>();
  seed.forEach((item) => merged.set(item.id, item));
  persisted.forEach((item) => merged.set(item.id, item));
  return Array.from(merged.values());
}

export function loadData(now: Date): AppData {
  const seed = createSeedData(now);

  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return seed;

    const persisted = JSON.parse(raw) as AppData;
    if (!isAppData(persisted)) return seed;

    const seedAppointmentIds = new Set(seed.appointments.map((item) => item.id));
    const userAppointments = persisted.appointments.filter((item) => !seedAppointmentIds.has(item.id));

    return {
      owners: mergeById(seed.owners, persisted.owners),
      pets: mergeById(seed.pets, persisted.pets),
      appointments: [...seed.appointments, ...userAppointments],
    };
  } catch {
    return seed;
  }
}

export function saveData(data: AppData) {
  localStorage.setItem(STORAGE_KEY, JSON.stringify(data));
}
